import type { UniqAppConfig } from 'korint-sdk/react';

type IntermediaryInformationCard = NonNullable<
  NonNullable<UniqAppConfig['intermediaryDetailsPages']>['intermediaryInformations']
>[number];
type IntermediaryInformationCardModuleField = IntermediaryInformationCard['fields'][number];

const companyFields: Array<IntermediaryInformationCardModuleField> = [
  {
    accessorKey: 'companyInfo.name',
    key: 'name',
    type: 'text',
    allowEdition: true,
    required: true,
    formDataAccessor: value => ({ companyInfo: { name: String(value) } }),
  },
  {
    accessorKey: 'customFields.email',
    key: 'email',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.phoneNumber',
    key: 'phoneNumber',
    type: 'text',
    allowEdition: true,
  },
  {
    kind: 'group',
    key: 'address',
    fields: [
      {
        key: 'address',
        accessorKey: 'companyInfo.location.address',
        type: 'text',
        required: true,
      },
      {
        key: 'postCode',
        accessorKey: 'companyInfo.location.postCode',
        type: 'postcode',
        countries: ['FR'],
        required: true,
      },
      {
        key: 'city',
        accessorKey: 'companyInfo.location.city',
        type: 'text',
        required: true,
      },
    ],
    formDataAccessor: values => ({
      companyInfo: {
        location: {
          address: values.address === undefined ? undefined : String(values.address),
          postCode: values.postCode === undefined ? undefined : String(values.postCode),
          city: values.city === undefined ? undefined : String(values.city),
        },
      },
    }),
  },
  {
    accessorKey: 'companyInfo.siret',
    key: 'siret',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'companyInfo.nafCode',
    key: 'nafCode',
    type: 'text',
  },
  {
    accessorKey: 'customFields.orias',
    key: 'orias',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.employeeCount',
    key: 'employeeCount',
    type: 'number',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.ceoFirstName',
    key: 'ceoFirstName',
    type: 'text',
    allowEdition: true,
  },
];

const contactFields: Array<IntermediaryInformationCardModuleField> = [
  {
    accessorKey: 'customFields.contactLastName',
    key: 'contactLastName',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.contactFirstName',
    key: 'contactFirstName',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.contactEmail',
    key: 'contactEmail',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.contactPhoneNumber',
    key: 'contactPhoneNumber',
    type: 'text',
    allowEdition: true,
  },
];

export const intermediaryInformationCards: ReadonlyArray<IntermediaryInformationCard> = [
  { titleKey: 'companyInformation', fields: companyFields },
  { titleKey: 'contactInformation', fields: contactFields },
  {
    titleKey: 'bankingInformation',
    fields: [{ key: 'iban', accessorKey: 'customFields.iban', type: 'text', allowEdition: true }],
  },
  {
    titleKey: 'comment',
    fields: [
      { key: 'comment', accessorKey: 'customFields.comment', type: 'text', allowEdition: true },
    ],
  },
];
